import "./Header.css";
import { useEffect, useState } from "react";
import { FaSearch, FaUser, FaHeart, FaShoppingBag, FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      try {
        setLoggedInUser(JSON.parse(user));
      } catch (err) {
        console.error("Error parsing user:", err);
      }
    } else {
      setLoggedInUser(null);
    }
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setLoggedInUser(null);
    navigate("/login");
  };

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    AOS.refresh();
    setMenuOpen(false); // close drawer when navigating
  }, [location]);
const offers = [
  "🔥 Culture at your finger tips",
  "✨ Customize to your satisfaction",
];


  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % offers.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header>
  {/* Sliding Offers */}
  <div className="offers-slider" data-aos="fade-right" data-aos-delay="200">
    <div
      className="offers-track"
      style={{ transform: `translateX(-${currentIndex * 100}%)` }}
    >
      {offers.map((offer, i) => (
        <div className="offer" key={i}>
          {offer}
        </div>
      ))}
    </div>
  </div>

  <div className="container">
    {/* Logo */}
    <Link to="/" className="logo-link" data-aos="fade-down" data-aos-delay="300">
      <img src={logo} className="logo" alt="ShawlHaus Logo" />
    </Link>

    {/* Desktop Navigation */}
    <nav className="nav-links-desktop">
      <NavLink to="/" end>Home</NavLink>
      <NavLink to="/about">About</NavLink>
      <NavLink to="/customization">Product</NavLink>
      <NavLink to="/shawls">Shawls</NavLink>
      <NavLink to="/contact">Contact Us</NavLink>
    </nav>

    {/* Icons + Mobile Hamburger */}
    <div className="icons" data-aos="fade-up" data-aos-delay="800">
      {loggedInUser ? (
        <div className="user-menu">
          <Link to="/profile" title="My Profile" className="user-link">
            <FaUser />
            <span>{loggedInUser.name || "Profile"}</span>
          </Link>
          <button onClick={handleLogout} className="logout-btn-header" title="Logout">
            <FaSignOutAlt />
          </button>
        </div>
      ) : (
        <Link to="/login" className="login-link">
          <FaUser />
          <span>Login</span>
        </Link>
      )}

      {/* Mobile Hamburger */}
      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </div>
  </div>

  {/* Mobile Drawer */}
  <nav className={`nav-links-mobile ${menuOpen ? "open" : ""}`}>
    <NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink>
    <NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink>
    <NavLink to="/customization" onClick={() => setMenuOpen(false)}>Products</NavLink>
    <NavLink to="/shawls" onClick={() => setMenuOpen(false)}>Shawls</NavLink>
    <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</NavLink>
  </nav>

  {/* Overlay */}
  <div className={`overlay ${menuOpen ? "show" : ""}`} onClick={() => setMenuOpen(false)}></div>
</header>

  );
};

export default Header;
